var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.msg)?_c('v-alert',{staticClass:"alert",attrs:{"type":"error"}},[_vm._v(" "+_vm._s(_vm.msg)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }